import React from "react"
import { Grid, Icon } from "semantic-ui-react"
import "./SetupGuide.css"

const GUIDE_STEPS = {
  bank: {
    label: "Checking + Savings",
    icon: "money",
    tooltip: "Regular bank accounts like checking and savings"
  },
  creditcard: {
    label: "Credit Cards",
    icon: "credit card",
    tooltip: "Credit card accounts"
  },
  investment: {
    label: "Investments",
    icon: "bar chart",
    tooltip: "Investment accounts like 401(k)'s or brokerage accounts"
  },
  loan: {
    label: "Loans",
    icon: "university",
    tooltip: "Mortgages and other loans, if you have any"
  },
  insurance: {
    label: "Insurance",
    icon: "protect",
    tooltip: "Life insurance, if you have any"
  },
  health: {
    label: "Health",
    icon: "doctor",
    tooltip: "Health Savings Account, if you have one"
  }
}

const GuideStep = ({ icon, label, tooltip, isCompleted }) => (
  <div data-tooltip={tooltip}>
    <Icon
      name={icon}
      fitted
      size="big"
      className={isCompleted ? "SetupGuide__Completed" : ""}
      color={isCompleted ? "blue" : "grey"}
      disabled={!isCompleted}
    />
    {isCompleted ? (
      <Icon
        name="check"
        color="green"
        size="tiny"
        circular
        inverted
        className="SetupGuide__GreenCheck"
      />
    ) : null}
    <p
      className="SetupGuide__Label"
      style={{ paddingTop: "0.2em", color: isCompleted ? "black" : "#C1C1C1" }}
    >
      {label}
    </p>
  </div>
)

export const SetupGuide = ({ completedSteps }) => {
  const stepNames = completedSteps.concat(
    Object.keys(GUIDE_STEPS).filter(
      stepName => !completedSteps.includes(stepName)
    )
  )
  return (
    <Grid textAlign="center" className="SetupGuide__Grid">
      <Grid.Row>
        <Grid.Column>
          <p className="greyed-label" style={{ paddingBottom: "0.5em" }}>
            Have you collected everything? Be sure to build a complete financial
            picture
          </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={12}>
        {stepNames.map(stepName => {
          const step = GUIDE_STEPS[stepName]
          return (
            step && (
              <Grid.Column width={2} textAlign="center" key={step.label}>
                <GuideStep
                  icon={step.icon}
                  label={step.label}
                  tooltip={step.tooltip}
                  isCompleted={completedSteps.includes(stepName)}
                />
              </Grid.Column>
            )
          )
        })}
      </Grid.Row>
    </Grid>
  )
}
